import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-what-makes-us-different',
    templateUrl: './what-makes-us-different.component.html',
    styleUrls: ['./what-makes-us-different.component.css']
})
export class WhatMakesUsDifferentComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
